import { render, staticRenderFns } from "./KalenderKegiatan.vue?vue&type=template&id=2136d7ec&scoped=true"
import script from "./KalenderKegiatan.vue?vue&type=script&lang=js"
export * from "./KalenderKegiatan.vue?vue&type=script&lang=js"
import style0 from "./KalenderKegiatan.vue?vue&type=style&index=0&id=2136d7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136d7ec",
  null
  
)

export default component.exports